import { render } from "./BankTransferSuccess.vue?vue&type=template&id=6e227823"
import script from "./BankTransferSuccess.vue?vue&type=script&lang=js"
export * from "./BankTransferSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__